import { Link } from 'react-router-dom';
import { Breadcrumbs, Link as MuiLink, Typography } from '@mui/material';
import useMyMenuItems from 'hooks/useMyMenuItems';

export type BreadcrumbProps = {
    poNumber?: string;
    recordTypeId: number;
};

export const Breadcrumb = ({ poNumber, recordTypeId }: BreadcrumbProps) => {
    const { getMenuItemByRecordTypeId, menuItemList } = useMyMenuItems();
    const menuItemTitle = menuItemList?.find((el) => Number(el.recordType?.id) === recordTypeId);
    const recordTypePath = getMenuItemByRecordTypeId?.(recordTypeId) || '';

    return (
        <Breadcrumbs separator=">">
            <MuiLink component={Link} underline="hover" key="1" color="inherit" to={recordTypePath}>
                <Typography color="#858585" fontSize={20} fontWeight={300}>
                    {menuItemTitle?.name || 'Order Details'}
                </Typography>
            </MuiLink>
            {poNumber && (
                <Typography key="3" color="secondary" fontSize={20} fontWeight={500} sx={{ textTransform: 'capitalize' }}>
                    {poNumber}
                </Typography>
            )}
        </Breadcrumbs>
    );
};
